var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("picture_as_pdf")]),
                  _vm._v(" Reportes de vacación\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c("v-flex", { attrs: { md6: "" } }, [
                            _c("strong", [_vm._v("FUNCIONARIO: ")]),
                            _vm._v(
                              _vm._s(_vm.$storage.get("user").nombres) +
                                "\n              " +
                                _vm._s(_vm.$storage.get("user").ap_paterno) +
                                "\n              " +
                                _vm._s(_vm.$storage.get("user").ap_materno) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticClass: "text-xs-center",
                          attrs: {
                            wrap: "",
                            "justify-center": "",
                            "align-center": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  color: "#16516f",
                                  label: "Fecha desde"
                                },
                                model: {
                                  value: _vm.fecha_desde,
                                  callback: function($$v) {
                                    _vm.fecha_desde = $$v
                                  },
                                  expression: "fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  color: "#16516f",
                                  label: "Fecha hasta"
                                },
                                model: {
                                  value: _vm.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.fecha_hasta = $$v
                                  },
                                  expression: "fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "#812595", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.verReporte(1)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Generar Reporte de vacaciones\n                "
                                  ),
                                  _c("v-icon", [_vm._v("description")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "pink", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.verReporte(2)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Generar Reporte programación anual\n                "
                                  ),
                                  _c("v-icon", [_vm._v("picture_as_pdf")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [_c("HistoricoPeriodosVacacion")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78d809c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d809c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/ReporteVacacionesFuncionario.vue
// module id = null
// module chunks = 